// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__21YTf","calendarButtons":"ClockData_calendarButtons__3i0Uk"};